<template>
  <Button
    type="button"
    label="Run"
    icon="pi pi-play"
    class="text-color"
    :loading="queryStore.queryRunning"
    @click="queryStore.runQuery()"
  />
</template>

<script setup>
import Button from "primevue/button";
import { useQueryStore } from "@/stores/queryStore.js";

const queryStore = useQueryStore();
</script>

<style scoped></style>
